"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _topicService = require("../services/topicService");

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _button = require("@insided/deprecated-preact-components/design-system-components/button");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DeletePollModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(DeletePollModal, _PureComponent);

  var _super = _createSuper(DeletePollModal);

  function DeletePollModal() {
    var _this;

    (0, _classCallCheck2.default)(this, DeletePollModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDeletePoll", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, contentType, topicId, onShowAlert, onPollUpdate, onTogglePollEditor, onClose;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, contentType = _this$props.contentType, topicId = _this$props.topicId, onShowAlert = _this$props.onShowAlert, onPollUpdate = _this$props.onPollUpdate, onTogglePollEditor = _this$props.onTogglePollEditor, onClose = _this$props.onClose;
              _context.prev = 1;
              _context.next = 4;
              return (0, _topicService.deletePoll)(contentType, topicId);

            case 4:
              onPollUpdate({
                title: '',
                options: []
              });

              _this.setState({
                isLoading: false
              });

              onClose();
              onTogglePollEditor(false);
              onShowAlert('success', 'Poll successfully deleted');
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              onShowAlert('error', 'Something went wrong, please try again later.');

            case 14:
              _this.setState({
                isLoading: false
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(DeletePollModal, [{
    key: "render",
    value: function render() {
      var onClose = this.props.onClose;
      var isLoading = this.state.isLoading;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: "Are you sure you want to delete the poll permanently?"
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("p", null, "The poll will not be visible in the topic anymore.")), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_button.ButtonGroup, null, (0, _preact.h)(_Button.default, {
        title: "Delete poll",
        variant: "warning",
        onClick: this.onDeletePoll,
        isLoading: isLoading,
        "data-qa": "delete-poll",
        size: "medium"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        onClick: onClose,
        size: "medium"
      }))));
    }
  }]);
  return DeletePollModal;
}(_preactCompat.PureComponent);

var _default = DeletePollModal;
exports.default = _default;